<template>
  <v-layout row>
    <v-flex xs12 sm10 offset-sm1>
      <v-toolbar flat color="white">
        <v-tooltip bottom>
          <v-btn icon light @click="$router.go(-1)" slot="activator">
            <v-icon color="grey darken-2">arrow_back</v-icon>
          </v-btn>
          <span>{{ $vuetify.t('$vuetify.app.back') }}</span>
        </v-tooltip>
        <v-toolbar-title
          >{{ $vuetify.t('$vuetify.calls.media') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-layout row wrap mt-3 mb-3>
        <v-flex xs12 md4>
          <v-card
            color="pink darken-2"
            :class="{
              'mr-3': $vuetify.breakpoint.mdAndUp,
              'mb-3': $vuetify.breakpoint.smAndDown
            }"
            :to="{ name: 'camera', params: { media: 'photo' } }"
          >
            <v-card-text class="white--text text-xs-center">
              <v-icon x-large color="white">photo_camera</v-icon>
              <div class="headline text-xs-center">
                {{ $vuetify.t('$vuetify.calls.takePhoto') }}
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
        <!--
        <v-flex xs12 md4>
          <v-card color="deep-purple darken-2" :class="{'mr-3': $vuetify.breakpoint.mdAndUp, 'mb-3': $vuetify.breakpoint.smAndDown}" :to="{ name: 'camera', params: { media: 'video' } }">
              <v-card-text class="white--text text-xs-center">
                  <v-icon x-large color="white">videocam</v-icon>
                  <div class="headline text-xs-center">{{ $vuetify.t('$vuetify.calls.recordVideo') }}</div>
              </v-card-text>
          </v-card>
        </v-flex>
        -->
        <v-flex xs12 md4>
          <v-card color="blue darken-2" class="uploadButton btn-file">
            <v-card-text class="white--text text-xs-center">
              <v-icon x-large color="white">attach_file</v-icon>

              <div class="headline text-xs-center">Upload Photos</div>

              <input
                type="file"
                @change="handleFiles"
                ref="photoFiles"
                multiple
                accept="image/*"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout mb-3 mt-1 row wrap v-if="uploadProgress">
        <v-flex md6 xs12>
          <v-progress-linear
            v-model="uploadProgress"
            height="30"
            color="orange"
          >
            {{ uploadProgress }}%
          </v-progress-linear>
        </v-flex>
      </v-layout>
      <media-list :mediaItems="getMediaList(callDetail)" />
    </v-flex>
  </v-layout>
</template>

<script>
import MediaList from '@/components/MediaList.vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import helpers from '../utils/helpers'

export default {
  name: 'Media',
  components: {
    MediaList
  },
  computed: {
    ...mapState({
      uploadProgress: state => state.calls.uploadProgress
    }),
    ...mapGetters({
      activeCallId: 'calls/activeCallId',
      callDetail: 'calls/getActiveCall'
    })
  },
  data() {
    return {}
  },
  created() {
    window.addEventListener('offline', () => {
      this.updateProgress(undefined)
      this.setNetworkStatus('offline')
      this.cancelRequest()
    })
    window.addEventListener('online', () => {
      this.setNetworkStatus(undefined)
    })
  },
  methods: {
    ...mapActions({
      addMedia: 'calls/addMedia',
      updateProgress: 'calls/updateProgress',
      setNetworkStatus: 'calls/setNetworkStatus',
      cancelRequest: 'calls/cancelRequest'
    }),

    getMediaList(call) {
      return call.media || []
    },
    async forEach(arr, callback) {
      for (let i = 0; i < arr; i++) {
        await callback(arr[i], i)
      }
    },
    handleFiles() {
      const callId = this.activeCallId
      this.files = this.$refs.photoFiles.files
      const _this = this
      Array.from(this.files).forEach(file => {
        const maxWidth = process.env.VUE_APP_IMG_MAX_WIDTH
        const maxHeight = process.env.VUE_APP_IMG_MAX_HEIGHT
        helpers.resizeImage(file, maxWidth, maxHeight).then(res => {
          const media = {}
          media.src = res
          media.name = file.name
          media.type = 'image'
          media.model_id = callId
          media.collection_name = 'media'
          _this.updateProgress(10)
          console.log('media', media)
          _this
            .addMedia({ id: callId, media: media })
            .then(() => {
              _this.$refs.photoFiles.value = null
            })
            .catch(e => {
              _this.$refs.photoFiles.value = null
              console.log(e, 'error')
            })
        })
      })
    }
  },
  destroyed: function() {
    window.removeEventListener('offline', this.updateProgress)
    window.removeEventListener('online', this.updateProgress)
  }
}
</script>

<style scoped lang="scss">
.uploadButton {
  cursor: pointer;
}
.btn-file {
  position: relative;
  overflow: hidden;
}
.btn-file input[type='file'] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  opacity: 0;
  outline: none;
  background: #fff;
  cursor: inherit;
  display: block;
}
</style>
